// Qulflanadigan ustunlar KATALOGI — super-admin shu ro'yxatdan tanlab, biror biznesda
// maxfiy ustunni yashiradi. Yangi ustun qulflansa — shu yerga 1 qator qo'shiladi.
//
// key         : backend/frontend bir xil ishlatadigan kalit ('col.<sahifa>.<maydon>').
// label       : i18n kaliti (3 tilga tarjima locales/*.json da).
// Bo'lim (section) — vizual guruhlash uchun; label ham i18n kaliti.
//
// MUHIM: kalit ClientDebt.js dagi isColumnHidden('...') va backend colMap bilan bir xil bo'lsin.

export const COLUMN_LOCK_CATALOG = [
	{
		section: 'report_clients',
		sectionLabel: 'clients', // "Mijozlar"
		columns: [
			{ key: 'col.report_clients.debt_age', label: 'debt_age' },
			{ key: 'col.report_clients.pay_reliability', label: 'pay_reliability' },
			{ key: 'col.report_clients.last_purchase', label: 'col_last_purchase' }, // Oxirgi xarid + Aktiv
		],
	},
]

// Barcha kalitlar (tekshirish uchun)
export const ALL_COLUMN_KEYS = COLUMN_LOCK_CATALOG.flatMap((s) => s.columns.map((c) => c.key))
